import {
  CREATE_SOCIAL_LINK,
  CREATE_SOCIAL_LINK_FAILURE,
  CREATE_SOCIAL_LINK_SUCCESS,
  DELETE_SOCIAL_LINK,
  DELETE_SOCIAL_LINK_FAILURE,
  DELETE_SOCIAL_LINK_SUCCESS,
  GET_SOCIAL_LINK,
  GET_SOCIAL_LINKS,
  GET_SOCIAL_LINKS_FAILURE,
  GET_SOCIAL_LINKS_SUCCESS,
  GET_SOCIAL_LINK_FAILURE,
  GET_SOCIAL_LINK_SUCCESS,
  UPDATE_SOCIAL_LINK,
  UPDATE_SOCIAL_LINK_FAILURE,
  UPDATE_SOCIAL_LINK_SUCCESS,
} from "./actionTypes";

export const getSocialLinks = (payload) => {
  return {
    type: GET_SOCIAL_LINKS,
    payload,
  };
};

export const getSocialLinksSuccess = (payload) => {
  return {
    type: GET_SOCIAL_LINKS_SUCCESS,
    payload,
  };
};

export const getSocialLinksFailure = (payload) => {
  return {
    type: GET_SOCIAL_LINKS_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const getSocialLink = (payload) => {
  return {
    type: GET_SOCIAL_LINK,
    payload,
  };
};

export const getSocialLinkSuccess = (payload) => {
  return {
    type: GET_SOCIAL_LINK_SUCCESS,
    payload,
  };
};

export const getSocialLinkFailure = (payload) => {
  return {
    type: GET_SOCIAL_LINK_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const createSocialLink = (payload) => {
  return {
    type: CREATE_SOCIAL_LINK,
    payload,
  };
};

export const createSocialLinkSuccess = (payload) => {
  return {
    type: CREATE_SOCIAL_LINK_SUCCESS,
    payload,
  };
};

export const createSocialLinkFailure = (payload) => {
  return {
    type: CREATE_SOCIAL_LINK_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const updateSocialLink = (payload) => {
  return {
    type: UPDATE_SOCIAL_LINK,
    payload,
  };
};

export const updateSocialLinkSuccess = (payload) => {
  return {
    type: UPDATE_SOCIAL_LINK_SUCCESS,
    payload,
  };
};

export const updateSocialLinkFailure = (payload) => {
  return {
    type: UPDATE_SOCIAL_LINK_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================

export const deleteSocialLink = (payload) => {
  return {
    type: DELETE_SOCIAL_LINK,
    payload,
  };
};

export const deleteSocialLinkSuccess = (payload) => {
  return {
    type: DELETE_SOCIAL_LINK_SUCCESS,
    payload,
  };
};

export const deleteSocialLinkFailure = (payload) => {
  return {
    type: DELETE_SOCIAL_LINK_FAILURE,
    payload,
  };
};

// ===================================================
// ===================================================
